/* eslint-disable */
// tslint:disable
/**
 * Кабинет муниципалитета
 * todo
 *
 * OpenAPI spec version: 1.4.0
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */

export namespace Api {
	export interface ApiContentPublicSubjectSchoolsGet401 {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof ApiContentPublicSubjectSchoolsGet401
		 */
		description: string;
	}

	export interface CreateFeedbackRequest {
		fio: string;
		workplace_position: string;
		phone?: string;
		email?: string;
		text: string;
		attachment_ids?: number[];
		form_source?: Api.CreateFeedbackRequest.FormSourceEnum;
		municipality?: string;
		region?: string;
	}
	
	/**
	 * @export
	 * @namespace CreateFeedbackRequest
	 */
	export namespace CreateFeedbackRequest {
		export enum FormSourceEnum {
			Cabmun = 'cabmun',
			MiniApp = 'mini_app'
		}
	
	}

	export interface GetBanners200Response {
		/**
		 * @type {number}
		 * @memberof GetBanners200Response
		 */
		id: number;
		img: string | null;
		title: string;
		text: string;
		link: string;
		buttonTitle: string;
		section: string;
		buttons?: (Api.GetBanners200Response.Button[]) | null;
	}
	
	/**
	 * @export
	 * @namespace GetBanners200Response
	 */
	export namespace GetBanners200Response {
		export interface Button {
			title: string;
			type: string | null;
			color: string;
			bgColor: string;
			link: string;
		}
	
	}

	export interface GetMunicipalityTasks200Response {
		plate1?: Api.GetMunicipalityTasks200Response.Plate1;
		plate2?: Api.GetMunicipalityTasks200Response.Plate2;
		plate3?: Api.GetMunicipalityTasks200Response.Plate3;
		plate4?: Api.GetMunicipalityTasks200Response.Plate4;
	}
	
	/**
	 * @export
	 * @namespace GetMunicipalityTasks200Response
	 */
	export namespace GetMunicipalityTasks200Response {
		export interface Plate1 {
			status?: boolean;
		}
	
		export interface Plate2 {
			status?: boolean;
			/**
			 * @type {number | null}
			 * @memberof Plate2
			 */
			count?: number | null;
		}
	
		export interface Plate3 {
			status?: boolean;
		}
	
		export interface Plate4 {
			status?: boolean;
		}
	
	}

	export interface GetPopups200Response {
		/**
		 * @type {number}
		 * @memberof GetPopups200Response
		 */
		id: number;
		title: string;
		text: string;
		link: string;
		buttonTitle: string;
	}

	export interface GetStatistics200Response {
		/**
		 * @type {number}
		 * @memberof GetStatistics200Response
		 */
		activated_teachers: number;
		/**
		 * @type {number}
		 * @memberof GetStatistics200Response
		 */
		rewarded_teachers: number;
	}

	export interface GetSubjectSchools200Response {
		/**
		 * @type {number}
		 * @memberof GetSubjectSchools200Response
		 */
		id: number;
		short_name: string;
		location: string;
	}

	export interface GetTeacherReviews200Response {
		/**
		 * @type {number}
		 * @memberof GetTeacherReviews200Response
		 */
		id: number;
		title: string;
		text: string;
		label: string;
	}

	export interface GetTeacherReviewsRequest {
		/**
		 * @type {number}
		 * @memberof GetTeacherReviewsRequest
		 */
		region: number;
		period: string;
	}

	export interface GetTsokTotals200Response {
		/**
		 * @type {number}
		 * @memberof GetTsokTotals200Response
		 */
		activation_count: number;
		/**
		 * @type {number}
		 * @memberof GetTsokTotals200Response
		 */
		criterion_compleated_count: number;
		/**
		 * @type {number}
		 * @memberof GetTsokTotals200Response
		 */
		active_student_count: number;
	}

	export interface GetUserDataStudentCount200Response {
		/**
		 * @type {number}
		 * @memberof GetUserDataStudentCount200Response
		 */
		school_id?: number;
		/**
		 * @type {number}
		 * @memberof GetUserDataStudentCount200Response
		 */
		subject_id?: number;
		/**
		 * @type {number}
		 * @memberof GetUserDataStudentCount200Response
		 */
		student_count?: number;
	}

	export interface GetWebinars200Response {
		/**
		 * @type {number}
		 * @memberof GetWebinars200Response
		 */
		id: number;
		name: string;
		startDate: string | null;
		endDate: string | null;
		/**
		 * @type {number | null}
		 * @memberof GetWebinars200Response
		 */
		externalId: number | null;
		details: string | null;
		target: string | null;
	}

	export interface GetWebinarsPdf404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetWebinarsPdf404Response
		 */
		description: string;
	}

	export interface Gratitude {
		/**
		 * @type {number}
		 * @memberof Gratitude
		 */
		id: number;
		created_at: string;
		reason: string | null;
		type: string;
		cover: string;
		title: string;
		section?: Api.Gratitude.SectionEnum;
	}
	
	/**
	 * @export
	 * @namespace Gratitude
	 */
	export namespace Gratitude {
		export enum SectionEnum {
			_1 = 1,
			_2 = 2
		}
	
	}

	export interface GratitudesAvailable {
		years: Api.GratitudesAvailable.Year[];
		/**
		 * @type {number | null}
		 * @memberof GratitudesAvailable
		 */
		last_added_timestamp: number | null;
	}
	
	/**
	 * @export
	 * @namespace GratitudesAvailable
	 */
	export namespace GratitudesAvailable {
		export interface Year {
			year: string;
			/**
			 * @type {number}
			 * @memberof Year
			 */
			quantity: number;
		}
	
	}

	export interface LoggedShowBannerRequest {
		/**
		 * @type {number}
		 * @memberof LoggedShowBannerRequest
		 */
		subjectId: number;
	}

	export interface LoggedShowPopupRequest {
		/**
		 * @type {number}
		 * @memberof LoggedShowPopupRequest
		 */
		subjectId: number;
	}

	export interface RegionIndicatorsResponse {
		/**
		 * @type {number}
		 * @memberof RegionIndicatorsResponse
		 */
		ab_test_group: number;
		academic_students_performance: Api.RegionIndicatorsResponse.AcademicStudentsPerformance[];
		students_engagement: Api.RegionIndicatorsResponse.StudentsEngagement[];
	}
	
	/**
	 * @export
	 * @namespace RegionIndicatorsResponse
	 */
	export namespace RegionIndicatorsResponse {
		export interface AcademicStudentsPerformance {
			/**
			 * @type {number}
			 * @memberof AcademicStudentsPerformance
			 */
			subject_id: number;
			subject_name: string;
			school_subject: string;
			group: string;
			/**
			 * @type {number}
			 * @memberof AcademicStudentsPerformance
			 */
			value: number;
		}
	
		export interface StudentsEngagement {
			/**
			 * @type {number}
			 * @memberof StudentsEngagement
			 */
			subject_id: number;
			subject_name: string;
			/**
			 * @type {number}
			 * @memberof StudentsEngagement
			 */
			value: number;
		}
	
	}

	export interface SetUserDataStudentCount401Response {
		error?: string;
	}

	export interface SetUserDataStudentCountRequest {
		/**
		 * <p>0 если логируем данные по школе</p>
		 * @type {number}
		 * @memberof SetUserDataStudentCountRequest
		 */
		subject_id: number;
		/**
		 * <p>0 если логируем данные по субъекту</p>
		 * @type {number}
		 * @memberof SetUserDataStudentCountRequest
		 */
		school_id: number;
		/**
		 * @type {number}
		 * @memberof SetUserDataStudentCountRequest
		 */
		student_count: number;
		/**
		 * <p>2022/2023</p>
		 * @type {string}
		 * @memberof SetUserDataStudentCountRequest
		 */
		academic_year?: string;
	}

	export interface StudentsEngagement2 {
		/**
		 * @type {number}
		 * @memberof StudentsEngagement2
		 */
		subject_id: number;
		subject_name: string;
		/**
		 * @type {number}
		 * @memberof StudentsEngagement2
		 */
		value: number;
	}

	export interface SurveyResponse {
		survey_id: string;
		responses: Api.SurveyResponse.Response[];
		is_multistage_answers?: boolean;
	}
	
	/**
	 * @export
	 * @namespace SurveyResponse
	 */
	export namespace SurveyResponse {
		export interface Response {
			question: string;
			answer: string | null;
		}
	
	}

	export interface TsokActivity {
		/**
		 * <p>id региона</p>
		 * @type {number | null}
		 * @memberof TsokActivity
		 */
		region_id: number | null;
		/**
		 * <p>id субъекта</p>
		 * @type {number}
		 * @memberof TsokActivity
		 */
		subject_id: number;
		/**
		 * <p>id школы</p>
		 * @type {number | null}
		 * @memberof TsokActivity
		 */
		school_id: number | null;
		/**
		 * <p>id школы</p>
		 * @type {number}
		 * @memberof TsokActivity
		 */
		criterion_compleated_count: number;
		/**
		 * <p>id школы</p>
		 * @type {number}
		 * @memberof TsokActivity
		 */
		activation_count: number;
	}

	export interface TsokStatisticByMonth2 {
		/**
		 * <p>Дата замера (первый день месяца)</p>
		 * @type {string}
		 * @memberof TsokStatisticByMonth2
		 */
		sample_date: string;
		/**
		 * <p>выполнили условие</p>
		 * @type {number}
		 * @memberof TsokStatisticByMonth2
		 */
		value: number;
		/**
		 * <p>id школы</p>
		 * @type {number | null}
		 * @memberof TsokStatisticByMonth2
		 */
		school_id: number | null;
		/**
		 * <p>id школы</p>
		 * @type {number | null}
		 * @memberof TsokStatisticByMonth2
		 */
		subject_id: number | null;
		/**
		 * <p>id региона</p>
		 * @type {number | null}
		 * @memberof TsokStatisticByMonth2
		 */
		region_id: number | null;
	}

	export interface TsokStatisticBySchoolSubjectsItem {
		/**
		 * <p>Название предмета</p>
		 * @type {string}
		 * @memberof TsokStatisticBySchoolSubjectsItem
		 */
		school_subject: string;
		/**
		 * <p>primary or middle of high</p>
		 * @type {string}
		 * @memberof TsokStatisticBySchoolSubjectsItem
		 */
		group: string;
		/**
		 * @type {number}
		 * @memberof TsokStatisticBySchoolSubjectsItem
		 */
		students_count: number;
		/**
		 * @type {number | null}
		 * @memberof TsokStatisticBySchoolSubjectsItem
		 */
		municipality_id: number | null;
		/**
		 * @type {number | null}
		 * @memberof TsokStatisticBySchoolSubjectsItem
		 */
		school_id: number | null;
	}

	export interface UpdateStatusTaskRequest {
		taskName: string;
	}

	export interface UploadFeedbackAttachment200Response {
		/**
		 * @type {number}
		 * @memberof UploadFeedbackAttachment200Response
		 */
		id: number;
	}

	export interface UploadFeedbackAttachmentRequest {
		file?: string | Blob;
	}
	
	/**
	 * @export
	 * @namespace UploadFeedbackAttachmentRequest
	 */
	export namespace UploadFeedbackAttachmentRequest {
		export interface MultipartFormData {
			file?: Api.UploadFeedbackAttachmentRequest.MultipartFormData.FilePart;
		}
		
		/**
		 * @export
		 * @namespace MultipartFormData
		 */
		export namespace MultipartFormData {
			export interface FilePart {
				value: string | Blob;
				filename?: string;
			}
		
		}
	
	}

}
